import { ActionType } from 'typesafe-actions';
import * as filterAction from './filters';
import * as importedOrganizationAction from './importedOrganization';
import * as pageInfoAction from './pageInfo';
import * as sortingAction from './sorting';

export const IMPORTED_ORGANIZATION_ACTION_PREFIX = 'IMPORTED_ORGANIZATION';

export const importedOrganizationActions = { ...importedOrganizationAction };
export const filterActions = { ...filterAction };
export const pageInfoActions = { ...pageInfoAction };
export const sortingActions = { ...sortingAction };

export type ImportedOrganizationActions = ActionType<typeof importedOrganizationAction>;
export type FilterActions = ActionType<typeof filterAction>;
export type PageInfoActions = ActionType<typeof pageInfoAction>;
export type SortingActions = ActionType<typeof sortingAction>;
